import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SelectAllComponent} from './select-all.component';
import {MatListModule, MatSelectModule} from '@angular/material';

@NgModule({
  imports: [
    CommonModule,
    MatSelectModule,
    MatListModule
  ],
  declarations: [
    SelectAllComponent
  ],
  exports: [
    SelectAllComponent
  ]
})
export class CuiSelectAllModule {
}



// WEBPACK FOOTER //
// ./node_modules/@cicero/webui/lib/core/select-all/select-all.module.ts